/**
 * Created by anair on 02/26/17.
 */


import React from 'react';
import {render} from 'react-dom';

class StartWalkthroughModal extends React.Component {


  hide = () => {
    this.props.hide();
  }

  gotoWalkthrough = () => {
    this.props.gotoWalkthrough();
  }


  render() {
    return (
        <div className="walkthrough-mdl-container">
            <div className="walkthrough-mdl">
                <div className="walkthrough-mdl-header">
                    <div className="text-style">{this.props.selectedUseCase.title}</div>
                </div>
                <div className="walkthrough-mdl-header-body-divider">
                </div>
                <div className="walkthrough-mdl-body">
                    <div className="walkthrough-mdl-body-text-style">
                        <div className="header-text-style">
                            {this.props.content.description}
                        </div>
                        <div className="body-text-style">
                            {this.props.selectedUseCase.description}
                        </div>
                    </div>
                </div>
                <div className="walkthrough-mdl-footer">
                    <div className="walkthrough-start-button" onClick={this.gotoWalkthrough}>
                        {this.props.content.buttons.start}
                    </div>
                    <div className="cancel-button" onClick={this.hide}>
                        {this.props.content.buttons.cancel}
                    </div>
                </div>
            </div>
        </div>

    );
  }

}

export default StartWalkthroughModal;
